

//  export const BASE_URL_FOXBERRY =  'https://21q3ct84-9111.inc1.devtunnels.ms/v1';
export const BASE_URL_FOXBERRY = 'https://api.sampada.foxberry.live/v1';

export const BASE_URL = 'https://api.sampada.foxberry.live/v1';
// export const BASE_URL = 'https://21q3ct84-9111.inc1.devtunnels.ms/v1';



